// extracted by mini-css-extract-plugin
export default {"button":"RemoveOrgUser_button__v1tb7"};